/** Allowed when the user types in a license plate field (no hyphen/space/symbols). */
const LICENSE_PLATE_INPUT_DISALLOWED = /[^A-Za-z0-9ÄÖÜäöü]/g;

/** Letter class including German umlauts (for parsing combined values). */
export const LICENSE_PLATE_LETTER_CLASS = 'A-Za-zÄÖÜäöü';

/**
 * Strip disallowed characters from user input.
 * Hyphens are never accepted from typing — Germany adds them when joining segments.
 */
export function filterLicensePlateInput(str) {
    if (str == null || typeof str !== 'string') return '';
    return str.replace(LICENSE_PLATE_INPUT_DISALLOWED, '');
}

/**
 * Sanitize a stored/combined plate string.
 * @param {string} raw
 * @param {{ preserveHyphen?: boolean }} opts
 */
export function sanitizeLicensePlateStored(raw, { preserveHyphen = false } = {}) {
    const s = String(raw ?? '');
    if (preserveHyphen) {
        return s.replace(new RegExp(`[^${LICENSE_PLATE_LETTER_CLASS}0-9-]`, 'g'), '');
    }
    return filterLicensePlateInput(s);
}
